import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '商圈监控-青田县侨乡进口商品城',
    component: () => import('../views/Home.vue'),
    meta: { title: '平台预警-青田县侨乡进口商品城' }
  },
  {
    path: '/business',
    name: '商圈展示',
    component: () => import('../views/Business.vue'),
    meta: { title: '商圈展示-青田县侨乡进口商品城' }
  },
  {
    path: '/equipment',
    name: '智慧设备管理',
    component: () => import('../views/Equipment.vue'),
    meta: { title: '平台预警-青田县侨乡进口商品城' }
  },
  {
    path: '/jingdianguanli',
    name: '街区景点管理',
    component: () => import('../views/jingdianguanli.vue'),
    meta: { title: '街区景点管理-青田县侨乡进口商品城' }
  },
  {
    path: '/shangpuguanli',
    name: '营销分析-青田县侨乡进口商品城',
    component: () => import('../views/shangPuGuanLi.vue'),
    meta: { title: '营销分析-青田县侨乡进口商品城' }
  },
  {
    path: '/renliufenxi',
    name: '客流分析-青田县侨乡进口商品城',
    component: () => import('../views/renLiuFenXi.vue'),
    meta: { title: '客流分析-青田县侨乡进口商品城' }
  },
  {
    path: '/control',
    name: '控制终端',
    component: () => import('../views/control.vue'),
    meta: { layout: 'control' }
  },
  {
    path: '/overview',
    name: '5D可视化大数据仓',
    component: () => import('../views/Overview.vue'),
    meta: { title: '5D可视化大数据仓' }
  },
  {
    path: '/fireworks',
    name: '大屏互动',
    component: () => import('../views/fireworks.vue'),
    meta: { title: '大屏互动', layout: 'firework' }
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, _, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
